import { $t } from '@/utils/languageAuto';
import { __decorate, __extends } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import Breadcrumb from '@/components/breadcrumb/index.vue';
import addOrEdit from '@/views/order/returnOrder/fbaRemovalOrder/addOrEdit/index.vue';

var ReturnOrderAddPage = function (_super) {
  __extends(ReturnOrderAddPage, _super);

  function ReturnOrderAddPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.breadcrumbData = [];
    return _this;
  }

  ReturnOrderAddPage.prototype.created = function () {
    this.breadcrumbData = [{
      routerName: 'ReturnOrderPage',
      title: this.t('退货管理'),
      query: {
        order_type: this.$enum.order.ReturnOrderType.FbaRemovalOrder
      }
    }, {
      title: this.t('新增FBA移除退仓单')
    }];
  };

  ReturnOrderAddPage = __decorate([Component({
    components: {
      Breadcrumb: Breadcrumb,
      addOrEdit: addOrEdit
    }
  })], ReturnOrderAddPage);
  return ReturnOrderAddPage;
}(Vue);

export default ReturnOrderAddPage;